// extracted by mini-css-extract-plugin
export default {"upperTextContainer":"Result_upperTextContainer__dQ-V3","subTitle":"Result_subTitle__wfV2o","title":"Result_title__m0cNE","content":"Result_content__YglFg"};